import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { reportDropDownRecordList } from "../../../Api/api";

// Define an initial state for the slice
const initialState = {
   data: null,
   loading: false,
   error: null,
};





export const reportDropDownRecordAsync=createAsyncThunk(
   "report/dropDown",
   async ({ done, err }, thunkAPi) => {
      try {
         
         const { data: response } = await reportDropDownRecordList();
         if (response.statusCode === 200) {
            done && done(response.res);
            return thunkAPi.fulfillWithValue(response.res);
         } else {
            throw response;
         }
      } catch (error) {
         // You can customize the error handling here
         
         err && err(error.message);
         return thunkAPi.rejectWithValue(error);
      }
   }

);

const reportDropDownRecordSlice = createSlice({
   name: "reportDropDown",
   initialState,
   reducers: {

   },
   extraReducers: (builder) => {
      builder
         .addCase(reportDropDownRecordAsync.pending, (state) => {
            state.loading = true;
            state.error = null;
         })
         .addCase(reportDropDownRecordAsync.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            // 
         })
         .addCase(reportDropDownRecordAsync.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload; // error message from the rejectWithValue call
         });
   },
});



export default reportDropDownRecordSlice.reducer;